import React, {Component} from 'react'
import styles from './InfoCampaign.css'
import DataTable from "../../components/DataTable/DataTable"
import {TypeInfoCampaign, TypeRoute} from "../../constants/consts-prop-types"
import {loadImage} from "../../services/service-image-loader"

class InfoCampaign extends Component {
  static propTypes = {
    currentRoute: TypeRoute,
    data: TypeInfoCampaign
  }

  constructor(props) {
    super(props)

    this.state = {
      imageSrc: null
    }
  }

  componentDidMount() {
    const { info_screen: image_url } = this.props.data.image.sizes;

    this.resetText();
    this.enterText();
    if (image_url) loadImage(image_url, this);
  }

  componentDidUpdate(prevProps) {
    const {image_url} = this.props.data

    if(image_url !== prevProps.data.image_url) {
      this.resetText()
      this.enterText()
      if(image_url) loadImage(image_url, this)
    }
  }

  resetText() {
    if(this.nodeHeader1) window.TweenLite.set(this.nodeHeader1, {opacity: 0, transform: 'translateX(10vw)'})
    if(this.nodeHeader2) window.TweenLite.set(this.nodeHeader2, {opacity: 0, transform: 'translateX(10vw)'})
    if(this.subHeader) window.TweenLite.set(this.subHeader, {opacity: 0, transform: 'translateX(10vw)'})
    if(this.nodeHeader3) window.TweenLite.set(this.nodeHeader3, {opacity: 0, transform: 'translateX(10vw)'})
    if(this.nodeHeader4) window.TweenLite.set(this.nodeHeader4, {opacity: 0, transform: 'translateY(-2vw)'})
  }

  enterText() {
    const time = .9
    const del = '-=.6'
    this.tl = new window.TimelineLite();
    this.tl.stop()
    if(this.nodeHeader1) this.tl.add(window.TweenLite.to(this.nodeHeader1, time, {opacity: 1, transform: 'translateX(0)'}), del)
    if(this.nodeHeader2) this.tl.add(window.TweenLite.to(this.nodeHeader2, time, {opacity: 1, transform: 'translateX(0)'}), del)
    if(this.subHeader) this.tl.add(window.TweenLite.to(this.subHeader, time, {opacity: 1, transform: 'translateX(0)'}), del)
    if(this.nodeHeader3) this.tl.add(window.TweenLite.to(this.nodeHeader3, time, {opacity: 1, transform: 'translateX(0)'}), del)
    if(this.nodeHeader4) this.tl.add(window.TweenLite.to(this.nodeHeader4, time, {opacity: 1, transform: 'translateY(0)'}), del)
    window.TweenLite.to(this.tl, 2, {progress: 1, easing: window.Circ.easeOut, delay: .5});
  }

  render() {
    const {
      category,
      header_bold,
      header_light,
      header_sub,
      manchet,
      data_list,
      colors,
    } = this.props.data;
    const { background: backgroundColor, foreground: color } = colors || {};

    const { imageSrc } = this.state;
    const lang =
      document.documentElement.lang.length > 2
        ? "da"
        : document.documentElement.lang;

    return (
      <div className={styles.InfoCampaign} style={{ backgroundColor, color }}>
        <img
          src={imageSrc}
          className={styles.backgroundImage}
          style={{
            opacity: imageSrc ? 1 : 0,
            objectFit: "cover",
          }}
          alt={header_bold}
        />
        <div className="container-fluid">
          <div className="row" style={{ height: "100%" }}>
            <div className={"col-xs-12"}>
              <div className={styles.content}>
                {/* {category && <p className={styles.category}>{category}</p>} */}

                <div>
                  {header_bold && (
                    <h1
                      lang={lang}
                      ref={(node) => (this.nodeHeader1 = node)}
                      className={styles.animationInit}
                      dangerouslySetInnerHTML={{ __html: header_bold }}
                    />
                  )}
                  {header_light && (
                    <h2
                      ref={(node) => (this.nodeHeader2 = node)}
                      className={`secondary ${styles.animationInit}`}
                      dangerouslySetInnerHTML={{ __html: header_light }}
                    />
                  )}
                  {header_sub && (
                    <p
                      ref={(node) => (this.subHeader = node)}
                      className={styles.subHeader}
                      dangerouslySetInnerHTML={{ __html: header_sub }}
                    />
                  )}
                  {manchet && (
                    <p
                      ref={(node) => (this.nodeHeader3 = node)}
                      className={styles.manchet}
                      dangerouslySetInnerHTML={{ __html: manchet }}
                    />
                  )}
                </div>
                {data_list && (
                  <div
                    ref={(node) => (this.nodeHeader4 = node)}
                    className={styles.animationInit2}
                  >
                    <DataTable items={data_list} className={styles.dataTable} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InfoCampaign



// WEBPACK FOOTER //
// ./src/components/InfoCampaign/InfoCampaign.js